import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import DropdownRenderer from './renderers/Dropdown/DropdownRenderer';
import SnippetSelectionRenderer from './renderers/SnippetSelection/SnippetSelectionRenderer.react';
import PassageCorrectionRenderer from './renderers/PassageCorrection/PassageCorrectionRenderer.react';
import BasicRenderer from './renderers/BasicRenderer/BasicRenderer.react';

import {setMarkdownRenderer} from './markdownRendererRef';

import './markdown-renderer.scss';

const MarkdownRendererV2 = (props) => {
  const {className, dropdowns, passageCorrection, snippetSelectionData, text} = props;
  const rendererRef = React.useRef(null);

  // Regions without math never gate; clearing the marker up front keeps math added by a later
  // content update from hiding the whole region.
  React.useLayoutEffect(() => {
    const renderer = rendererRef.current;
    if (renderer && !renderer.querySelector('[data-mathjax-pending]')) {
      renderer.removeAttribute('data-mathjax-initial-render');
    }
  }, []);

  let Renderer;

  if (dropdowns) {
    Renderer = DropdownRenderer;
  } else if (snippetSelectionData) {
    Renderer = SnippetSelectionRenderer;
  } else if (passageCorrection) {
    Renderer = PassageCorrectionRenderer;
  } else {
    Renderer = BasicRenderer;
  }

  return (
    <div
      ref={rendererRef}
      className={classnames(
        'markdown-renderer-v2',
        '[&[data-mathjax-initial-render]:has([data-mathjax-pending])]:invisible',
        className
      )}
      data-mathjax-initial-render=''
    >
      <Renderer {...props} text={!text ? '' : text} />
    </div>
  );
};

MarkdownRendererV2.propTypes = {
  className: PropTypes.string,
  dropdowns: PropTypes.object,
  isBeingTranslated: PropTypes.bool,
  passageCorrection: PropTypes.bool,
  snippetSelectionData: PropTypes.object,
  text: PropTypes.string,
  highlight: PropTypes.string
};

// Register with the neutral ref so recursive sub-renderers and supplement/question components can
// resolve this component at render time without importing it directly (which would re-form a cycle).
setMarkdownRenderer(MarkdownRendererV2);

export default MarkdownRendererV2;
